import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { deliveryPassImageSize } from './ProductComparisonCard';
const useStyles = makeStyles()((theme) => ({
    deliveryPassContainer: {
        padding: spacing.medium,
        width: '100%',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.12)',
        background: colors.background.WHITE,
    },
    topSectionContainer: {
        display: 'flex',
        borderBottom: `1px solid ${colors.grey.grey3}`,
        flexDirection: 'column',
        marginBottom: '3px',
    },
    topSectionContainerComparison: {
        [theme.breakpoints.between('sm', 'md')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
    },
    deliveryPassImage: {
        width: `${deliveryPassImageSize.width}px`,
        height: `${deliveryPassImageSize.height}px`,
        aspectRatio: `${deliveryPassImageSize.width} / ${deliveryPassImageSize.height}`,
        objectFit: 'cover',
    },
    purchaseButton: {
        '&.MuiButtonBase-root.MuiButton-root': { padding: `15px ${spacing.medium} 13px`, textWrap: 'nowrap' },
        marginBottom: spacing.medium,
    },
    purchaseButtonComparison: {
        [theme.breakpoints.between('sm', 'md')]: {
            marginBottom: 0,
            width: 'auto',
            alignSelf: 'flex-start',
        },
    },
    deliveryPassProductName: Object.assign(Object.assign({ display: 'block' }, theme.typography.medium_bold), { marginTop: spacing.small, marginBottom: 0 }),
    deliveryPassPrice: Object.assign(Object.assign({}, theme.typography.xl_bold), { lineHeight: '2.5rem', marginBottom: spacing.medium }),
    bottomSectionContainer: {
        marginTop: spacing.medium,
    },
    keyProductMessageContainer: {
        display: 'flex',
    },
    iconClass: Object.assign(Object.assign({}, theme.typography.small_regular), { marginRight: spacing.xs, color: `${colors.grey.grey7}` }),
    deliveryPassKeyProductMessaging: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: colors.grey.grey7, textAlign: 'left', overflowWrap: 'break-word' }),
    recommendBadge: Object.assign(Object.assign({}, theme.typography.large_bold), { paddingLeft: spacing.small, paddingRight: spacing.small, backgroundColor: colors.background.PURPLE, color: colors.backgroundText.PURPLE, textAlign: 'center' }),
    recommendedContainer: {
        background: colors.background.LILAC,
        color: colors.backgroundText.LILAC,
        border: `1px solid ${colors.background.PURPLE}`,
    },
}));
export default useStyles;
